export const WizardStepSkeleton = () => (
  <>
    <div className="shadow-introBox bg-white w-full  rounded-[16px]">
      <div className=" space-y-4 px-[16px] py-[32px] md:p-[32px]">
        <div className="h-4 animate-pulse bg-gray-200 rounded w-1/4"></div>
        <div className="h-10 animate-pulse bg-gray-200 rounded"></div>
        <div className="h-10 animate-pulse bg-gray-200 rounded"></div>
        <div className="flex space-x-4">
          <div className="h-10 animate-pulse bg-gray-200 rounded w-1/2"></div>
          <div className="h-10 animate-pulse bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    </div>

    <div className="flex items-center space-x-4 lg:space-x-0 justify-between mt-[24px] md:shadow-md bg-white rounded-[16px] px-0 py-[32px] md:p-[32px] font-outfit">
      <div className="w-[218px]">
        <div className="h-10 animate-pulse bg-gray-200 rounded w-full"></div>
      </div>
      <div className="hidden lg:block  flex-1 text-center">
        <div className=""></div>
      </div>
      <div className="w-[218px]">
        <div className="h-10 animate-pulse bg-gray-200 rounded w-full"></div>
      </div>
    </div>
  </>
);
